module.exports = __webpack_public_path__ + "img/PAUD.f677eb70.png";